import React, { useState } from "react";

const AnalyteResultWidget = (props) => {
  const {
    value,
    onChange,
    placeholder,
    formContext,
    disabled,
    options,
    schema,
  } = props;

  const label = options.label;
  const rangeText = formContext?.datas?.[label]?.["Reference range guidance"];
  const units = formContext?.datas?.[label]?.["Units"];

  const [tableData, setTableData] = useState(
    Array.from({ length: 4 }, () => Array(4).fill(""))
  );

  const updateCell = (row, col, text) => {
    const newData = [...tableData];
    newData[row][col] = text;

    setTableData(newData);

    onChange(JSON.stringify(newData));
  };

  const parseRange = (rangeText) => {
    if (!rangeText) return { min: null, max: null };
    const clean = rangeText.toLowerCase().trim();

    if (clean.includes("up to")) {
      const match = clean.match(/up to\s*(\d+(\.\d+)?)/i);
      const num = match ? parseFloat(match[1]) : null;
      return { min: null, max: num };
    }

    if (clean.startsWith("<")) {
      const num = parseFloat(clean.replace(/[^\d.]/g, ""));
      return { min: null, max: num };
    }

    if (clean.startsWith(">")) {
      const num = parseFloat(clean.replace(/[^\d.]/g, ""));
      return { min: num, max: null };
    }

    const rangeMatches = [
      ...clean.matchAll(
        /(-?[\d,]+(?:\.\d+)?)\s*(?:-|–|to)\s*(-?[\d,]+(?:\.\d+)?)/gi
      ),
    ];
    if (rangeMatches.length > 0) {
      const first = rangeMatches[0];
      const min = parseFloat(first[1].replace(/,/g, ""));
      const max = parseFloat(first[2].replace(/,/g, ""));
      return { min, max };
    }

    const num = parseFloat(clean.replace(/[^\d.]/g, ""));
    if (!isNaN(num)) {
      return { min: num, max: num };
    }

    return { min: null, max: null };
  };

  const { min, max } = parseRange(rangeText);
  const numValue = parseFloat(value);

  const isValid = !value
    ? true
    : (min !== null && numValue < min) || (max !== null && numValue > max)
    ? false
    : true;

  const isUnitsEmpty = !units || units.trim() === "";

  return (
    <div style={{ width: "100%" }}>
      <div style={{ position: "relative" }}>
        {Array.isArray(options.enumOptions) &&
        options.enumOptions.length > 0 ? (
          <select
            className="form-control"
            value={value || ""}
            disabled={disabled}
            onChange={(e) => onChange(e.target.value)}
          >
            {options.enumOptions.map((opt, i) => (
              <option key={i} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        ) : (
          <input
            type={isUnitsEmpty ? "text" : "number"}
            className={`form-control ${
              !isValid && !isUnitsEmpty ? "is-invalid" : ""
            }`}
            placeholder={placeholder}
            value={value || ""}
            disabled={disabled}
            onChange={(e) => onChange(e.target.value)}
          />
        )}

        {value && !isValid && !isUnitsEmpty && (
          <span
            style={{
              color: "red",
              position: "absolute",
              right: "-15px",
              top: "50%",
              transform: "translateY(-50%)",
              fontWeight: "bold",
            }}
          >
            !
          </span>
        )}
      </div>

      {props.options.label === "TYPE" && props.value === "GROWTH" && (
        <div
          style={{
            marginTop: 20,
            border: "1px solid #ccc",
            padding: 20,
            width: "100%",
            background: "#f8f8f8",
          }}
        >
          <table
            style={{
              borderCollapse: "collapse",
              width: "100%",
              minHeight: "300px",
            }}
            className="table table-bordered"
          >
            <tbody>
              {[0, 1, 2, 3].map((row) => (
                <tr key={row}>
                  {[0, 1, 2, 3].map((col) => (
                    <td
                      key={col}
                      contentEditable
                      suppressContentEditableWarning={true}
                      onInput={(e) => updateCell(row, col, e.target.innerText)}
                      style={{
                        border: "1px solid #ccc",
                        width: "25%",
                        height: "70px",
                        background: "white",
                        padding: 10,
                      }}
                    >
                      {tableData[row][col]}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AnalyteResultWidget;
